/* global indexPOUrl updatePOUrl deletePOUrl cancelPOUrl togglePOUrl approvalPOStatuses pendingPOStatus indexPOUrlApproved */
/* global indexPOUrlRejected indexPOUrlCanceled */

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import PurchaseOrdersIndexTable from './PurchaseOrdersIndexTable';

export default function PurchaseOrdersIndex(props) {
    const [fetchPending, setFetchPending] = useState(false);
    const [fetchApproved, setFetchApproved] = useState(false);
    const [fetchRejected, setFetchRejected] = useState(false);
    const [fetchCanceled, setFetchCanceled] = useState(false);

    const refetchAll = () => {
        setFetchPending(true);
        setFetchApproved(true);
        setFetchRejected(true);
        setFetchCanceled(true);
    };

    return (
        <div className="tw-space-y-10">
            <PurchaseOrdersIndexTable
                heading={$t('Pending Expenditure Approvals')}
                indexPOUrl={props.indexPOUrl}
                updateUrl={props.updatePOUrl}
                deleteUrl={props.deletePOUrl}
                cancelUrl={props.cancelPOUrl}
                toggleUrl={props.togglePOUrl}
                approvalStatuses={props.approvalPOStatuses}
                pendingStatus={props.pendingPOStatus}
                refetch={fetchPending}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchPending}
                type="pending"
                typeFormatted="Pending"
            />

            <PurchaseOrdersIndexTable
                heading={$t('Approved Expenditure Approvals')}
                indexPOUrl={props.indexPOUrlApproved}
                updateUrl={props.updatePOUrl}
                deleteUrl={props.deletePOUrl}
                cancelUrl={props.cancelPOUrl}
                approvalStatuses={props.approvalPOStatuses}
                pendingStatus={props.pendingPOStatus}
                refetch={fetchApproved}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchApproved}
                type="approved"
                typeFormatted="Approved"
            />

            <PurchaseOrdersIndexTable
                heading={$t('Rejected Expenditure Approvals')}
                indexPOUrl={props.indexPOUrlRejected}
                updateUrl={props.updatePOUrl}
                deleteUrl={props.deletePOUrl}
                cancelUrl={props.cancelPOUrl}
                approvalStatuses={props.approvalPOStatuses}
                pendingStatus={props.pendingPOStatus}
                refetch={fetchRejected}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchRejected}
                type="rejected"
                typeFormatted="Rejected"
            />
        </div>
    );
}

if (document.getElementById('purchaseOrdersIndex')) {
    var root = document.getElementById('purchaseOrdersIndex');
    ReactDOM.render(
        <App>
            <PurchaseOrdersIndex
                approvalPOStatuses={approvalPOStatuses}
                pendingPOStatus={pendingPOStatus}
                indexPOUrl={indexPOUrl}
                updatePOUrl={updatePOUrl}
                deletePOUrl={deletePOUrl}
                cancelPOUrl={cancelPOUrl}
                togglePOUrl={togglePOUrl}
                indexPOUrlApproved={indexPOUrlApproved}
                indexPOUrlRejected={indexPOUrlRejected}
                indexPOUrlCanceled={indexPOUrlCanceled}
            />
        </App>,
        root,
    );
}
